import {createFileRoute} from '@tanstack/react-router';
import EditPage from '@features/flow/[id]/edit/page';

export const Route = createFileRoute('/flow/$id_/edit')({
  component: function FlowEditPage() {
    const {id} = Route.useParams();
    return (
      <>
        <EditPage id={id} />
        <title>Banani | Edit</title>
      </>
    );
  },
});
